import { useEffect, useState } from 'react';

import { api } from '@/lib/api';

import { lerBadges } from '@alianca/core/contracts/identidade';
import type { Badges } from '@alianca/core/contracts/identidade';

export const BADGES_POLL_MS = 60_000;

/** Contadores da sidebar por polling de 60 s, pausado com a aba oculta (T07 §3.7, D-F1). */
export function useBadges(): Badges | null {
    const [badges, setBadges] = useState<Badges | null>(null);

    useEffect(() => {
        let ativo = true;
        const carregar = () => {
            if (document.visibilityState !== 'visible') return;
            api(lerBadges, {})
                .then((b) => ativo && setBadges(b))
                .catch(() => undefined);
        };
        carregar();
        const id = window.setInterval(carregar, BADGES_POLL_MS);
        document.addEventListener('visibilitychange', carregar);
        return () => {
            ativo = false;
            window.clearInterval(id);
            document.removeEventListener('visibilitychange', carregar);
        };
    }, []);

    return badges;
}
